import { Component, effect, inject, model, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { IPromocionImpresoraData } from '@core/interfaces/entidades/promocion-impresora.entidad';
import { PromocionImpresoraApiService } from '@core/services/api/promocion-impresora-api.service';
import { CardPromocionImpresora } from '@shared/components/card-promocion-impresora/card-promocion-impresora';
import { InputBuscador } from '@shared/components/input-buscador/input-buscador';
import { UiButton, UiDialog } from '@shared/components/ui';
import { CrearPromocionImpresora } from '@shared/components/crear-promocion-impresora/crear-promocion-impresora';
import { AppService } from '@shared/services/app.service';
import { SucursalService } from '@shared/services/sucursal.service';

@Component({
  selector: 'app-promocion-impresora',
  imports: [CardPromocionImpresora, InputBuscador, UiButton, UiDialog, CrearPromocionImpresora],
  templateUrl: './promocion-impresora.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './promocion-impresora.css',
})
export class PromocionImpresora implements OnInit {
  constructor() {
    effect(() => {
      if (this.sucursalService.sucursalReady() && this.appService.authReady()) {
        this.api.cargar().subscribe((data) => {
          this.promociones.set(data);
        });
      }
    });
  }
  ngOnInit(): void {
    this.appService.setPanelHeader({
      title: 'Promociones de Impresora',
      subtitle: 'Gestiona las promociones y cupones que se imprimen en los comprobantes',
      showBackButton: true,
      icon: 'bi bi-ticket-perforated',
    });
  }
  private appService = inject(AppService);
  private api = inject(PromocionImpresoraApiService);
  private sucursalService = inject(SucursalService);

  promociones = model<IPromocionImpresoraData[]>([]);
  busqueda: string = '';
  modal_crear = model(false);

  onBuscar() {}

  closeCrear(data?: IPromocionImpresoraData) {
    this.modal_crear.set(false);
    if (data) {
      this.promociones.update((list) => [...list, data]);
    }
  }
}
